import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: false,
  users: [],
  data: {},
})

const { Types, Creators } = createActions({
  getOperatorReport: ['startAt', 'endAt'],
  setOperatorReport: ['data', 'users'],
  setOperatorReportLoading: ['val'],
})

export const getOperatorReportReducer = state => state.set('loading', true)

export const setOperatorReportReducer = (state, { data, users }) =>
  state
    .set('loading', false)
    .set('data', data)
    .set('users', users)

export const setOperatorReportLoadingReducer = (state, { val }) => state.set('loading', val)

export const operatorReportReducer = createReducer(INITIAL_STATE, {
  [Types.GET_OPERATOR_REPORT]: getOperatorReportReducer,
  [Types.SET_OPERATOR_REPORT]: setOperatorReportReducer,
  [Types.SET_OPERATOR_REPORT_LOADING]: setOperatorReportLoadingReducer,
})

export const OperatorReportTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/operatorReportReducer.js